"use client";
import { useTranslations } from "next-intl";

const colorGroups = {
  blackGroup: {
    tColour: "text-black-700",
    subTColour: "text-slate-500",
  },
  whiteGroup: {
    tColour: "text-white",
    subTColour: "text-white",
  },
  grayGroup: {
    tColour: "text-[#300B60]",
    subTColour: "text-[#300B60]",
  },
  pinkGroup: {
    tColour: "text-[#A271F2]",
    subTColour: "text-[#fff]",
  }
};

const posGroups = {
  center: {
    parentPos: "items-center",
    childPos: "text-center",
  },
  left: {
    childPos: "text-left",
  },
};
export const usePanelTitleHandler = ({
  sectionName,
  colourGroup,
  posGroup,
  bt,
}) => {
  const t = useTranslations();
  const PANEL_TITLES = {
    domain: {
      title: t("domain_pt"),
      breadCrumb: t("domain")
    },
    purchase: {
      title: t("domain_pt"),
      breadCrumb: t("purchase")
    },
    configuration: {
      title: t("domain_pt"),
      breadCrumb: t("configuration")
    },
    free_domain_registration: {
      title: t("free_domain"),
      breadCrumb: t("free_domain_breadcrumb")
    },
    domain_table: {
      title: t("domainTable_pt"),
      subTitle: t("domainTable_pst"),
    },
    dinamicPage: {
      title: "",
      subTitle: "",
    },
    trust: {
      title: t("trust_pt"),
      subTitle: t("trust_pst"),
    },
    web_hosting: {
      title: t("webHosting_pt"),
      subTitle: t("webHosting_pst"),
      breadCrumb: t("web_hosting")
    },
    web_server: {
      title: t("webServer_pt"),
      subTitle: t("webHosting_pst"),
      breadCrumb: t("web_hosting")
    },
    our_partners: {
      title: t("ourPartners_pt"),
      subTitle: t("ourPartners_pst"),
    },
    our_recent_works: {
      title: t("ourRecentWorksTitle"),
    },
    web_hosting_table: {
      title: t("whTable_pt"),
      subTitle: t("whTable_pst"),
    },
    any_question: {
      title: t("anyQuestion_pt"),
      subTitle: t("anyQuestion_pst"),
    },
    vps_hosting_title: {
      title: t("vpsHosting_pt"),
      subTitle: t("vpsHosting_pst"),
    },
    vps_hosting: {
      title: t("vps"),
      breadCrumb: t("vpsHosting"),
      subTitle: t("vpsHosting_pst"),
    },
    vps_hosting_table: {
      title: t("vpsHostingTable_pt"),
      subTitle: t("vpsHostingTable_pst"),
    },
    "dedicated_server": {
      title: t("server"),
      subTitle: t("server"),
      breadCrumb: t("server")
    },
    careers: {
      title: t("careers_pt"),
      subTitle: t("careers_pst"),
      breadCrumb: t("career"),
    },
    portfolio: {
      title: t("portfolio_pt"),
      subTitle: t("portfolio_pst"),
      breadCrumb: t("portfolio"),
    },
    testimonials: {
      title: t("testimonials_pt"),
      subTitle: t("testimonials_pst"),
    },
    home: {
      title: t("home_pt"),
      // subTitle: t("home_pst"),
    },
    faq_domain: {
      title: t("faq_domain_pt"),
      subTitle: t("faq_domain_pst"),
    },
    faq_free_domain: {
      title: t("faq_free_domain_pt"),
      subTitle: t("faq_free_domain_pst"),
    },
    why_free_domain: {
      title: t("why_free_domain_pt"),
    },
    benefits_free_domain: {
      title: t("benefits_free_domain_pt"),
    },
    faq_hosting: {
      title: t("faq_hosting_pt"),
      subTitle: t("faq_hosting_pst"),
    },
    faq_vps: {
      title: t("faq_vps_pt"),
      subTitle: t("faq_vps_pst"),
    },
    faq_server: {
      title: t("faq_server_pt"),
      subTitle: t("faq_server_pst"),
    },
    blog: {
      title: t("blog_pt"),
      subTitle: t("blog_pst"),
      breadCrumb: t("blog")
    },
    blog_details: {
      title: t("blogDetails_pt"),
      subTitle: t("blogDetails_pst"),
    },
    about_us: {
      title: t("aboutUs_pt"),
      subTitle: t("aboutUs_pst"),
      breadCrumb: t("aboutUs"),
    },
    haqqimizda: {
      breadCrumb: t("aboutUs"),
    },
    our_team: {
      title: t("ourTeam_pt"),
      subTitle: t("ourTeam_pst"),
    },
    job_details: {
      title: t("jobDetails_pt"),
      subTitle: t("jobDetails_pst"),
      breadCrumb: t("career"),
    },
    contact: {
      title: t("contact_pt"),
      subTitle: t("contact_pst"),
      breadCrumb: t("contactUs"),
    },
    application_form: {
      title: t("applicationForm_pt"),
    },
    get_quote: {
      title: t("getQuote_pt"),
      subTitle: t("getQuote_pst"),
    },
    startUp: {
      title: t("startUp_pt"),
      subTitle: t("startUp_pst"),
      breadCrumb: "true"
    },
    website: {
      title: t("website_page_title"),
      subTitle: t("website_page_subtitle"),
      breadCrumb:  t("website"),
    },
    website_page_cards: {
      title: "Website Page Content Title",
    },
  };
  try {
    const { title = "", subTitle = "", breadCrumb } = PANEL_TITLES[sectionName] || {};
    const { tColour, subTColour } = colorGroups[colourGroup] || {};
    const mBt = bt ? "mb-[48px]" : "";
    const { parentPos, childPos } = posGroups[posGroup] || {};

    return {
      parentPos,
      childPos,
      title,
      subTitle,
      tColour,
      subTColour,
      mBt,
      breadCrumb,
      PANEL_TITLES
    };
  } catch (err) {
    console.log(err);
  }
};